import React, { useEffect } from 'react'
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import StageList from './StageList';
import Button from '@mui/material/Button';
import AddToPhotosOutlinedIcon from '@mui/icons-material/AddToPhotosOutlined';
import { useDispatch, useSelector } from 'react-redux';
import {
  get_company_process,
  get_company_process_stage,
  setCompany,
  setProcessHasJobForm,
  setProcessTab
} from '../../../store/user/userSlice';
import { isAuth } from '../../../helpers/cookies';
import IconButton from '@mui/material/IconButton';
import Search from '../home/Search';
import { useNavigate } from 'react-router-dom';
import { setJobData } from '../../../store/job/jobSlice';
// import { clearJobData } from '../../../store/job/jobSlice';

const ProcessList = (props) => {
  const {
    company_process,
    company_process_stage,
    selected_process_tab,
    selected_stage_tab,
    selected_company,
    ChildComponent
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user_company, is_job_form } = useSelector((state) => state.user);

  const handleProcessTabChange = (event, newValue) => {
    let company_id = selected_company ? selected_company : isAuth().company_id;
    let params = {
      company_id,
      process_id: newValue
    }
    dispatch(get_company_process_stage(params));
    dispatch(setProcessTab(newValue));
    dispatch(setProcessHasJobForm(newValue));
    dispatch(setJobData({}));
  };

  const handleSearchSubmit = () => {
    if (window.location.pathname !== "/") {
      navigate("/");
    }
  };
  useEffect(() => {
    if (company_process.length > 0) {
      const isCurrentSelectionValid = selected_process_tab && company_process.some(p => p.id === selected_process_tab);

      if (isCurrentSelectionValid) {
        // Ensure the process stages and form availability are set for the valid selection
        let company_id = selected_company ? selected_company : isAuth().company_id;
        let params = {
          company_id,
          process_id: selected_process_tab
        }
        dispatch(get_company_process_stage(params));
        dispatch(setProcessHasJobForm(selected_process_tab));
        return;
      }

      // Only default to first process if no valid selection exists
      let process_id = company_process[0].id;
      let company_id = selected_company ? selected_company : isAuth().company_id;
      let params = {
        company_id,
        process_id
      }
      dispatch(get_company_process_stage(params));
      dispatch(setProcessHasJobForm(process_id));
      dispatch(setJobData({}));
    }
  }, [company_process, selected_company, dispatch, selected_process_tab]);

  const handleCompanyChange = (event) => {
    const { value } = event.target;
    let company_id = value ? value : isAuth().company_id;
    dispatch(setCompany(value));
    dispatch(get_company_process(company_id));
  };

  // const handleClearCompany = (event) => {
  //   const company_id_reset = "";
  //   dispatch(clearJobData());
  //   navigate('/');
  //   const {value} = event.target;
  //   let company_id = value ? value : isAuth().company_id;    
  //   dispatch(setCompany(company_id_reset));
  //   dispatch(get_company_process(company_id));
  // };  

  const processesWithStages = company_process.filter(p => p.stage.length > 0);
  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      {
        (company_process.length && selected_process_tab) > 0 &&
        (
          <TabContext value={selected_process_tab}>
            <Stack
              display="flex"
              alignItems="center"
              sx={{
                flexDirection: { md: 'row', xs: 'column' }
              }}
            >

            </Stack>
            <Box sx={{
              "& .MuiTabPanel-root": {
                background: 'linear-gradient(#FFFFF 0%, #f5ad8bff 100%)',
                width: '100%',
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
                borderBottomRightRadius: "10px",
                padding: "0px",
              }
            }}>
              {
                company_process.map((process, idx) => {
                  return (
                    <TabPanel value={process.id} key={idx} sx={{
                      padding: '0px'
                    }}>
                      <StageList
                        company_process_stage={company_process_stage}
                        selected_stage_tab={selected_stage_tab}
                        selected_process_tab={selected_process_tab}
                        ChildComponent={ChildComponent}
                      />
                    </TabPanel>
                  )
                })
              }
            </Box>
          </TabContext>
        )
      }
    </Box>
  )
}

export default ProcessList;